/**
 * Gating des outils métier par activité déclarée à la souscription.
 * `activites` vide = tout débloqué (tenants existants / rétro-compat).
 */
import type { ReactNode } from "react";
import { Navigate } from "react-router";
import { useAuth } from "./AuthContext";

/** Route d'app spécifique à une activité → code activité requis. */
export const ACTIVITY_BY_ROUTE: Record<string, string> = {
  "/cynophile": "cynophile",
  "/ssiap": "ssiap",
  "/telesurveillance": "telesurveillance",
  "/evenementiel": "evenementiel",
};

/** Vrai si l'agence a accès à cette activité (vide = tout). */
export function hasActivity(activites: string[], activity: string): boolean {
  if (!activites || activites.length === 0) return true;
  return activites.includes(activity);
}

/** Garde une route d'activité : redirige vers / si non débloquée. */
export function RequireActivity({
  activity,
  children,
}: {
  activity: string;
  children: ReactNode;
}) {
  const { activites } = useAuth();
  if (!hasActivity(activites, activity)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
